import React from "react"
import { Analytics, useAnalytics } from "../../../packages/analytics/analytics.ts"

export const useExclusiveSheet = (exclusiveId: string) => {
  const [open, setOpen] = React.useState(false)
  const analytics = useAnalytics()

  const handleSetOpen = (open: boolean) => {
    setOpen(open)
    if (open) {
      analytics.track(Analytics.Event.ExclusiveViewed({ exclusiveId }))
    }
  }

  return [open, handleSetOpen] as const
}
